import { render } from "./AddFiliereModal.vue?vue&type=template&id=799a8218&ts=true"
import script from "./AddFiliereModal.vue?vue&type=script&lang=ts"
export * from "./AddFiliereModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__